import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';
import { Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const BreadCrumbs = ({ page, company_id }) => {
    const navigate = useNavigate();

    const breadcrumbs = [
        <Link
            key="1"
            color={page === 1 ? 'text.primary' : 'text.disabled'}
            fontSize={14}
            fontWeight={page === 1 ? 500 : 400}
            underline={page <= 1 ? 'none' : 'hover'}
            onClick={() => navigate('../application')}
            component={'button'}
            disabled={page <= 1}
        >
            Information
        </Link>,
        <Link
            key="2"
            color={page === 2 ? 'text.primary' : 'text.disabled'}
            fontSize={14}
            fontWeight={page === 2 ? 500 : 400}
            underline={page <= 2 ? 'none' : 'hover'}
            onClick={() => navigate(`../data-connection/${company_id}`)}
            component={'button'}
            disabled={page <= 2}
        >
            Data connection
        </Link>,
        // <Link
        //     key="3"
        //     color={page === 3 ? 'text.primary' : 'text.disabled'}
        //     fontSize={14}
        //     fontWeight={page === 3 ? 500 : 400}
        //     underline={page <= 3 ? 'none' : 'hover'}
        //     onClick={() => navigate(`/get-started/${company_id}`)}
        //     component={'button'}
        //     disabled={page <= 3}
        // >
        //     Get started
        // </Link>,
    ];

    return (
        <Stack spacing={2} mt={6} mb={1}>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
                {breadcrumbs}
            </Breadcrumbs>
        </Stack>
    );
};
